import React, { createContext, useContext, useState, useEffect } from 'react';
import { isMobile } from 'react-device-detect';

// Define the interaction modes
export type InteractionMode = 'drag-and-drop' | 'tap-to-location';

// Define the context type
interface InteractionModeContextType {
  mode: InteractionMode;
  setMode: (mode: InteractionMode) => void;
  selectedElement: any | null;
  setSelectedElement: (element: any | null) => void;
}

// Create the context with default values
const InteractionModeContext = createContext<InteractionModeContextType>({
  mode: 'drag-and-drop',
  setMode: () => {},
  selectedElement: null,
  setSelectedElement: () => {},
});

// Custom hook to use the context
export const useInteractionMode = () => useContext(InteractionModeContext);

// Provider component
export const InteractionModeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  // Set default mode based on device detection
  const [mode, setMode] = useState<InteractionMode>(isMobile ? 'tap-to-location' : 'drag-and-drop');
  const [selectedElement, setSelectedElement] = useState<any | null>(null);

  // Effect to clear selected element when mode changes
  useEffect(() => {
    setSelectedElement(null);
  }, [mode]);

  return (
    <InteractionModeContext.Provider value={{ mode, setMode, selectedElement, setSelectedElement }}>
      {children}
    </InteractionModeContext.Provider>
  );
};
